<template>
    <div class="list-items nav">
        <ul class="list-ul">
            <li class="list-li" v-for="(item,index) in items" @click="clickItem(item.id)">
                <div  :class="['item',{'activeBtn': item.id == currentIndex}]"  >
                    <div class="item-icon-container">
                        <img  v-if="logoType ==='img' "  class="item-icon"  :src="item.logo" />
                        <span  class="item-span" v-else v-html="item.logoSvg"></span>
                    </div>
                    <div class="item-name"> {{item.title}} </div>
                </div>
                <div class="submenu" v-if="item.children && item.children.length > 0">
                    <ul>
                        <li v-for="child in item.children"
                            :key="child.id"
                            @click.stop="clickItem(child.id)">
                            <a>{{child.title}}</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'list-items-html',
        props:{
            clickItem: Function,
            items:{
                type: Array,
            },
            currentIndex: String,
            logoType:{
                type : String,
                default: 'svg'
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .list-items{
        width:var(--list-items-width,100%);
        height: var(--list-items-height,auto);
        background-color: var(--list-items-bg-color,#f9f9f9);
        font-family: var(--list-items-font-family, sans-serif );

    }

    .list-ul {
        list-style-type: none;
        overflow: hidden;
        margin: var(--list-ul-margin,0%);
        padding: var(--list-ul-padding,0%);
        background-color: var(--list-items-list-ul-bg-color,#f9f9f9);
        width: var(--list-items-list-ul-width,100%);
        vertical-align: middle;
    }

    .list-li {
        height: 100%;
        display:var(--list-items-list-li-display,inline-block);
        width: calc(100% /(var(--list-number-items,6.5)));

    }


    .item{
        float: left;
        text-align:  var(--list-items-item-text-align,center);
        padding: var(--list-items-item-padding,16px);
        font-size: var(--list-items-item-font-size,1.15vw);
        height: var(--list-items-item-height,100%);
        margin: var(--list-items-item-margin,4%);
        border-radius:var(--list-items-item-border-radius,5px);
        width: var(--list-items-item-width,100%) ;
        color:var(--list-items-item-name-color,#6e6e6e) ;
        transition:var(--list-items-item-transition, all 0.2s);
        display: flex;
        align-items: center;

    }

    .item-icon-container{
        float: left;
        width: var(--list-items-item-icon-container-width,30%) ;
        height:  var(--list-items-item-icon-container-height,100%) ;
        padding: var(--list-items-item-icon-container-padding,0%);
        margin: var(--list-items-item-icon-container-margin,0%);

    }

    .item-icon{
        width: var(--list-items-item-icon-width,100%) ;
        height: var(--list-items-item-icon-height,100%) ;
        padding: var(--list-items-item-icon-padding,0%);
        margin: var(--list-items-item-icon-margin,0%);
    }


    .item-name{
        float: left;
        width:var(--list-items-item-name-width,70%) ;
        margin: var(--list-items-item-name-margin, 9%);
        padding: var(--list-items-item-name-padding,0%);

    }

    .item:hover {
        background-color: var(--list-items-item-over, #e3e3e3);
        cursor: pointer;
        color: var(--list-items-item-over-textcolor, #fff);
        fill: var(--list-items-item-hover-fillsvg, #fff);

    }
    .activeBtn {
        background-color: var(--list-items-item-active, #e3e3e3);
        fill:  var(--list-items-item-active-fillsvg,  #fff);
    }

    .nav li {
        &:hover {
            .submenu {
                display: block;
            }
        }
        .submenu {
            display:none;
            position:absolute;
            width:inherit;
            text-align:left;
            min-width: 100%;
            padding-top: 0;
            color: #ffffff;
            font-weight: 700;
            font-size: 0.9rem;
            top: 100%;
            box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
            z-index: 1;
            ul {
                background-color: var(--list-items-bg-color,#f9f9f9);
                position: relative;
                padding: 0;
                li {
                    display: block;
                    float:none !important;
                    height:auto;
                    line-height:32px;
                    cursor: pointer;
                    padding: 0 5px;
                    &:hover {
                        background-color: rgba(255, 255, 255, .5);
                    }
                    &:not(:last-child) {
                        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
                    }
                    a {
                        color: #ffffff;
                        &:hover {
                            text-decoration: none;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/list-items/src/components/Component.vue